'use client'
import type { FC } from 'react'
import type { StackProps } from '@chakra-ui/react'
import type { ProductPrice } from 'ecosystem'
import ProductPriceComponent from './ProductPrice'

type IProductDetailPriceProps = ProductPrice & StackProps

const ProductDetailPrice: FC<IProductDetailPriceProps> = (props) => {
  return (
    <ProductPriceComponent
      className="product-detail-price"
      flex={0}
      originalPriceProps={{
        textAlign: { base: 'center', md: 'left' },
        fontSize: {
          base: 'md',
          md: '2xl'
        },
        fontWeight: 'bold'
      }}
      priceProps={{
        textAlign: { base: 'center', md: 'left' },
        fontSize: {
          base: 'md',
          md: '2xl'
        },
        fontWeight: 'bold'
      }}
      {...props}
    />
  )
}

export default ProductDetailPrice
